"use client";

import { c as _c } from "react/compiler-runtime";
import { formatAddress, ModalBody, ModalFooter, ModalFooterButton, ModalHeader, ModalHeaderTitle } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { useLinkWallet } from "./use-link-wallet";
export const MoveLinkedWalletModalContent = t0 => {
  const $ = _c(32);
  const {
    address,
    goBack,
    onLinked
  } = t0;
  const t = useTranslations("MoveLinkedWalletModalContent");
  let t1;
  if ($[0] !== address || $[1] !== onLinked) {
    t1 = {
      address,
      onLinked
    };
    $[0] = address;
    $[1] = onLinked;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    linkWallet,
    isLinking
  } = useLinkWallet(t1);
  let t2;
  if ($[3] !== t) {
    t2 = t("title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <ModalHeader className="text-center"><ModalHeaderTitle className="text-center">{t2}</ModalHeaderTitle></ModalHeader>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== address || $[8] !== t) {
    t4 = t("description", {
      address: formatAddress(address)
    });
    $[7] = address;
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <ModalBody className="flex flex-col gap-6">{t4}</ModalBody>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("no");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== goBack || $[15] !== t6) {
    t7 = <ModalFooterButton onClick={goBack} variant="secondary">{t6}</ModalFooterButton>;
    $[14] = goBack;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== linkWallet) {
    t8 = () => {
      linkWallet({
        force: true
      });
    };
    $[17] = linkWallet;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t) {
    t9 = t("yesMoveWallet");
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== isLinking || $[22] !== t8 || $[23] !== t9) {
    t10 = <ModalFooterButton autoFocus={true} disabled={isLinking} isLoading={isLinking} onClick={t8} variant="primary">{t9}</ModalFooterButton>;
    $[21] = isLinking;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t7) {
    t11 = <ModalFooter>{t7}{t10}</ModalFooter>;
    $[25] = t10;
    $[26] = t7;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11 || $[29] !== t3 || $[30] !== t5) {
    t12 = <>{t3}{t5}{t11}</>;
    $[28] = t11;
    $[29] = t3;
    $[30] = t5;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  return t12;
};